export default __webpack_public_path__ + "static/285-c7b87ed3d184967b27f67aa689f573fa.gif";